// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"151":"component---src-components-dev-doc-template-index-tsx","244":"component---src-page-404-tsx","532":"styles","774":"framework"}[chunkId] + "-" + {"151":"cd97ddf4139014df8eaf","244":"dd515fc75166f7d5031e","532":"924dedfb962f77187e47","774":"a1c028437cc3ecff1a99"}[chunkId] + ".js";
};